import React, {FC} from "react";
import {Employee} from "../../../../../lib/src/api/dto/Employee";

export const ContactEmergencyCard: FC<{ employee: Employee }> = (props) => {
  return <div className={'grid grid-cols-2 gap-4'}>
    <div>Naam:</div>
    <div>{props.employee.metadata.emergencyContactName ?? '-'}</div>

    <div>Adres:</div>
    <div>{props.employee.metadata.emergencyContactAddress ?? '-'}</div>

    <div>Telefoonnummer:</div>
    <div>{props.employee.metadata.emergencyContactPhone ?? '-'}</div>
  </div>
}